module.exports = __webpack_public_path__ + "static/scale-model-of-midland-texas-9f0458deeb0d6734d10c159ee06c45fd.png";